import React, { FC, useState } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import * as yup from 'yup'
import { getAuthClient } from 'config'
import {
  constants,
  errorMsg,
  processErrorMsg,
  removeFocusFromField,
  storage,
} from 'utils'
import { BaseLayout, Loader } from 'components'
import { ForgotPasswordForm, EmailSentConfirmation } from './components'

const ForgotPassword: FC = () => {
  const { oktaAuth } = useOktaAuth()
  const [transaction, setTransaction] = useState<any | {}>({})
  const [showLoader, setShowLoader] = useState(false)
  const [serviceError, setServiceError] = useState('')

  const processSuccess = (response: any) => {
    setShowLoader(false)
    setTransaction(response)
  }

  const processError = (
    e: any,
    module: string,
    moduleDescription: string = '',
  ) => {
    setShowLoader(false)
    setServiceError(processErrorMsg(e, module, moduleDescription))
  }

  const handleSubmit = (values: any, { setSubmitting }: any) => {
    storage.setUser(values.username)
    removeFocusFromField()
    setSubmitting(true)

    setShowLoader(true)
    setServiceError('')

    const authClient = getAuthClient()

    authClient
      .forgotPassword({
        ...values,
        factorType: constants.OKTA_FACTOR_TYPE.EMAIL,
      })
      .then(processSuccess)
      .catch((error: any) => processError(error, 'Forgot Password'))
      .then(() => setSubmitting(false))
  }

  if (transaction.sessionToken) {
    oktaAuth.signInWithRedirect({ sessionToken: transaction.sessionToken })

    return null
  }

  let formContent: any
  let validationSchema: any
  let initialValues: any

  if (
    transaction.status === constants.OKTA_TRANSACTION_STATUS.RECOVERY_CHALLENGE
  ) {
    formContent = <EmailSentConfirmation serviceError={serviceError} />
  } else {
    initialValues = {
      username: '',
    }

    validationSchema = yup.object().shape({
      username: yup
        .string()
        .required(errorMsg.requiredField('Login Name'))
        .trim(),
    })

    formContent = (
      <ForgotPasswordForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        handleSubmit={handleSubmit}
        serviceError={serviceError}
      />
    )
  }

  return (
    <BaseLayout>
      <Loader visible={showLoader} />
      {formContent}
    </BaseLayout>
  )
}

export default ForgotPassword
